<template>
  <div id='bd-qrcode' align="center">
    <div id="qrcode"></div>
    <div style="margin-top: 20px;">
      <p>扫码登录萝卜丝</p>
      <el-button @click="switchUsername">用户名登录</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as util from '@/util/util'
const constants = require('@/util/constants')

export default {
  name: 'bd-qrcode',
  methods: {
    ...mapActions('stomp', [ 'stompConnectMQ' ]),
    switchUsername () {
      this.$router.replace('/login')
    }
  },
  mounted () {
    let uuid = 'login.' + constants.HTTP_CLIENT + '.' + util.guid()
    console.log('uuid:', uuid)
    // new QRCode($('#qrcode')[0], uuid)
    new QRCode($('#qrcode')[0], {
      text: uuid,
      width: 128,
      height: 128,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    this.stompConnectMQ(uuid)
  }
}
</script>

<style scoped>
#bd-qrcode {
  margin-top: 100px;
}
</style>
